'use client';
import './auth.scss';
import { Button, Box } from '@mui/material';
import * as React from 'react';

import { MixpanelTracking } from '@/services/mixpanel';
import { MixpanelEvent } from '@/services/eventEnums';
import { SigninProps } from './interfaces';
import { usePathname } from 'next/navigation';
import { isPlatformExplore } from '@/constants';

export default function Signin({ t }: SigninProps): React.ReactElement {
  const pathname = usePathname();
  const handleSignIn = () => {
    MixpanelTracking.getInstance().track(MixpanelEvent.ACCOUNT_SIGNIN_CLICK);
    const emailPasswordSignOnUrl = `/auth/login?returnTo=${pathname}`;
    // testing social signin feature with posthog
    if (isPlatformExplore) {
      const socialSignInUrl = `/auth/login?returnTo=${pathname}`;
      window.location.href = socialSignInUrl;
    } else {
      window.location.href = emailPasswordSignOnUrl;
    }
  };

  return (
    <Box>
      <Button name="Sign in" onClick={handleSignIn} variant="outlined" color="secondary" fullWidth>
        {t('signIn')}
      </Button>
    </Box>
  );
}
